import { FrontendConfigProvider as t } from "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "@apollo/client";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "react";
import "ramda";
import "../util/i18n/helper/locale.js";
import "react-i18next";
import { CurrencyProvider as d } from "../../currency-lib/contexts/CurrencyContext.js";
import { AccountProvider as n } from "./account/AccountContext.js";
import { Geetest4Provider as c } from "./account/Geetest4Context.js";
import { AdeptusProvider as p } from "./adeptus/AdeptusContext.js";
import { ApolloProvider as l } from "./apollo/ApolloProvider.js";
import { ConfigProvider as f, useConfigContext as P } from "./config/ConfigContext.js";
import { FingerPrintProvider as v } from "./fingerprint/FingerprintContext.js";
import { LanguageProvider as h } from "./language/LanguageContext.js";
import { RoleProvider as s } from "./role/RoleContext.js";
import { LogicControlProvider as a } from "./share/LogicControlContext.js";
import { MessageProvider as u } from "./share/MessageContext.js";
import { PersistQueryProvider as g } from "./share/PersistQueryContext.js";
import { PreloadProvider as C } from "./share/PreloadContext.js";
import { ReactQueryProvider as b } from "./share/ReactQueryContext.js";
import { ScreenLogProvider as L } from "./share/ScreenLogContext.js";
import { Web3Provider as y } from "./web3/Web3Context.js";
import { isAllowScreenLog as A } from "../util/environment/index.js";
import { RoninNameServiceProvider as S } from "../../wallet-lib/contexts/RoninNameServiceContext.js";
import { jsx as r } from "react/jsx-runtime";
const x = (i) => {
  var m;
  const {
    children: e
  } = i, {
    config: o
  } = P();
  return /* @__PURE__ */ r(L, {
    enabled: A(),
    children: /* @__PURE__ */ r(a, {
      children: /* @__PURE__ */ r(g, {
        children: /* @__PURE__ */ r(h, {
          children: /* @__PURE__ */ r(b, {
            children: /* @__PURE__ */ r(l, {
              children: /* @__PURE__ */ r(C, {
                children: /* @__PURE__ */ r(t, {
                  children: /* @__PURE__ */ r(y, {
                    children: /* @__PURE__ */ r(u, {
                      children: /* @__PURE__ */ r(c, {
                        children: /* @__PURE__ */ r(d, {
                          enabled: (m = o == null ? void 0 : o.currency) == null ? void 0 : m.enabled,
                          children: /* @__PURE__ */ r(p, {
                            children: /* @__PURE__ */ r(v, {
                              children: /* @__PURE__ */ r(n, {
                                children: /* @__PURE__ */ r(s, {
                                  children: /* @__PURE__ */ r(S, {
                                    children: e
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
}, rr = (i) => {
  const {
    children: e,
    config: o
  } = i;
  return /* @__PURE__ */ r(f, {
    config: o,
    children: /* @__PURE__ */ r(x, {
      children: e
    })
  });
};
export {
  rr as ShareLibProvider,
  rr as default
};
//# sourceMappingURL=ShareLibProvider.js.map
